/* @flow */
import React, { useContext } from "react";
import { withColorsProvider, type ColorSet } from "../ColorsProvider";
import PrecisionSlider from "../PrecisionSlider";
import UserLanguageContext from "../ContextWrappers/UserLanguageContext";

type Props = {
  colors: ColorSet,
  setpointIncrement: number,
  setpointCoolMin?: ?number,
  setpointCoolMax?: ?number,
  setpointCool?: ?number,
  setpointHeatMin?: ?number,
  setpointHeatMax?: ?number,
  setpointHeat?: ?number,
  onCoolValue: () => void,
  onHeatValue: () => void,
  onChangesStarted: () => void,
  onChangesEnd: () => void,
  formatter?: ?() => string,
  changeBufferMs: number,
  valueStyle: Object,
  hasAriaControls: boolean,
};

const ThermostatSetpointControls = (props: Props) => {
  const {
    colors,
    setpointIncrement,
    setpointCoolMin,
    setpointCoolMax,
    setpointCool,
    setpointHeatMin,
    setpointHeatMax,
    setpointHeat,
    onCoolValue,
    onHeatValue,
    onChangesStarted,
    onChangesEnd,
    formatter,
    changeBufferMs,
    valueStyle,
    hasAriaControls,
  } = props;

  const languageContext = useContext(UserLanguageContext);
  const language =
    languageContext.localeSet.nx_components.ThermostatSetpointControls;
  const valuesRegionId = "nx-components_ThermostatSetpoints_values";
  const ariaControls = hasAriaControls ? valuesRegionId : undefined;

  const styles = {
    cool: {
      color: colors.COOL,
    },
    heat: {
      marginTop: "0.5em",
      color: colors.HEAT,
    },
  };

  return (
    <div>
      {setpointCool ? (
        <PrecisionSlider
          hasOffState={false}
          label={`${language.coolTo}:`}
          unit="°"
          step={setpointIncrement}
          min={setpointCoolMin}
          max={setpointCoolMax}
          value={setpointCool}
          onValue={onCoolValue}
          onChangesStarted={onChangesStarted}
          onChangesEnded={onChangesEnd}
          formatter={formatter}
          changeBufferMs={changeBufferMs}
          valueStyle={valueStyle}
          style={styles.cool}
          isCool
          aria-controls={ariaControls}
        />
      ) : null}
      {setpointHeat ? (
        <PrecisionSlider
          hasOffState={false}
          label={`${language.heatTo}:`}
          unit="°"
          step={setpointIncrement}
          min={setpointHeatMin}
          max={setpointHeatMax}
          value={setpointHeat}
          onValue={onHeatValue}
          onChangesStarted={onChangesStarted}
          onChangesEnded={onChangesEnd}
          formatter={formatter}
          changeBufferMs={changeBufferMs}
          valueStyle={valueStyle}
          style={styles.heat}
          isHeat
          aria-controls={ariaControls}
        />
      ) : null}
    </div>
  );
};

export default withColorsProvider(ThermostatSetpointControls);



// WEBPACK FOOTER //
// ../nx-components/src/Thermostat/ThermostatSetpointControls.jsx